const KEY = "redux-app-storage";
const DEFAULT_VERSION = "0.0.0";

type ReduxStorageState = {
  version: string;
  state: unknown;
};

export function reduxLoadStateLocalStorage(version: string = DEFAULT_VERSION) {
  try {
    const serializedState = localStorage.getItem(KEY);
    if (!serializedState) return undefined;

    const stateParsed: ReduxStorageState = JSON.parse(serializedState);
    if (stateParsed?.version !== version) {
      console.warn(
        `Version mismatch: expected ${version}, but found ${stateParsed.version}.`,
      );
      return undefined;
    }

    return stateParsed?.state ?? undefined;
  } catch (e) {
    console.error(e);
  }

  return undefined;
}

export function reduxSaveStateLocalStorage(
  state: unknown,
  version: string = DEFAULT_VERSION,
) {
  try {
    const stateToSave: ReduxStorageState = {
      version,
      state,
    };
    const serializedState = JSON.stringify(stateToSave);
    localStorage.setItem(KEY, serializedState);
  } catch (e) {
    console.error(e);
  }
}
